import PropTypes from "prop-types";
import React from "react";
import styles from "./CuepointDot.css";

export default function CuepointDot(props) {
  const style = {
    left: `${props.percentStartTime}%`,
  };

  return (
    <div
      className={styles.cuepointDot}
      data-start-time={props.startTime}
      onMouseEnter={props.onMouseEnter}
      onMouseLeave={props.onMouseLeave}
      style={style}
    >
      <div className={styles.marker} />
      {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions */}
      <div
        className={styles.cuepointHit}
        onMouseDown={props.onMouseDown}
        onTouchEnd={props.onTap}
      />
    </div>
  );
}

CuepointDot.propTypes = {
  onMouseDown: PropTypes.func.isRequired,
  onMouseEnter: PropTypes.func.isRequired,
  onMouseLeave: PropTypes.func.isRequired,
  onTap: PropTypes.func.isRequired,
  percentStartTime: PropTypes.number.isRequired,
  startTime: PropTypes.number.isRequired,
};
